import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getArticlesDetails = createAsyncThunk('articles/getArticlesDetails',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await authGet(`/articles/details/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export const clearArticlesDetails = createAction('articles/clearArticlesDetails');

export default getArticlesDetails;
